import { Route, Routes } from "react-router-dom";
import "./App.css";
import CreateUser from "./pages/admin/NewUser";
import UserUpdate from "./pages/admin/UpdateUser";
import UserManagement from "./pages/admin/UserManagement";
import ViewUser from "./pages/admin/ViewUser";
import Dashboard from "./pages/dashboard.js/Dashboard";
import SignIn from "./pages/SignIn";
import AllPosts from "./pages/News/Posts";
import CreatePost from "./pages/News/CreatePost";
import AccountOpening from "./pages/account";
import ViewAccount from "./pages/account/ViewAccount";
import DocumentReview from "./pages/account/DocumentReview";
import ViewCustomer from "./pages/customers/ViewCustomer";
import CustomerList from "./pages/customers";
import AddComment from "./pages/account/AddComment";
import Transfers from "./pages/Transfer";
import Investments from "./pages/Investment";
import Rewards from "./pages/Rewards";
import ConfirmedCheque from "./pages/Cheque/ConfirmedCheque";
import ChequeBook from "./pages/Cheque/ChequeBook";
import DraftRequests from "./pages/Cheque/Draft";
import StopCheque from "./pages/Cheque/StopCheque";
import ActiveCards from "./pages/Cards/ActiveCards";
import ViewAccountSoleProprioetorship from "./pages/account/SoleProprietor.js";
import ViewAccountIncorporated from "./pages/account/Incorporated";
import PushNotification from "./pages/News/PushNotification";
import Rates from "./pages/Investment/Rates";
import CardRequest from "./pages/Cards/CardRequests";
import BlockCards from "./pages/Cards/BlockCard";
import BillPayment from "./pages/Payments/BillPayment";
import Recharge from "./pages/Payments/Airtime";
import ScheduledTransfers from "./pages/Transfer/ScheduledTransfer";
import GeneralTransfers from "./pages/Transfer/GeneralTransfers";
import CustomerSettngs from "./pages/customers/CustomerSettngs";
import Deposits from "./pages/Deposit";
import Withdrawals from "./pages/Withdrawal/index";
import CashPickUp from "./pages/Withdrawal/CashPickUp";
import PaydaySettings from "./pages/Loans/PaydaySettings";
import CashbasedSettings from "./pages/Loans/CashbasedSettings";
import ATMLocation from "./pages/News/ATMLocation";
import PayRoll from "./pages/Transfer/Payroll";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Roles from "./pages/admin/Roles";
import CreaateRole from "./pages/admin/NewRole";
import Notifications from "./pages/admin/Notification";
import UpdateRole from "./pages/admin/UpdateRole";
import ViewPickUp from "./pages/Withdrawal/ViewPickUp";
import Token from "./pages/Token";
import { useState, useEffect } from "react";
import IdleTimeOutHandler from "./components/TimeOut/IdleTimeOut";
import Promotion from "./pages/News/Promotion";
import CustomerDocument from "./pages/customers/customerDocument";
import BVNDetails from "./pages/customers/viewBVN";
import ApplicationModule from "./pages/appModules";
import POSRequest from "./pages/POS/index";
import MinorView from "./pages/account/viewMinor";
import MinorAccounts from "./pages/account/Minor";
import Complaint from "./pages/Chat/index";
import SalaryAccounts from "./pages/account/SalaryAccount";
import SalaryView from "./pages/account/viewSalary";
import ApplicationSettings from "./pages/applicationSettings/index";
import Beneficiaries from "./pages/Transfer/Beneficiaries";
import ViewBeneficiary from "./pages/Transfer/viewBeneficiary";
import AccountOfficer from "./pages/account/AccountOfficer";
import Tenant from "./pages/tenant";
import Budget from "./pages/Budget";
import UserAccounts from "./pages/account/UserAccounts";
import ViewUserAccount from "./pages/account/ViewUserAccount";
import AdminAudit from "./pages/AuditLogs/AdminAudit";
import CustomerAudit from "./pages/AuditLogs/CustomerAudit";
import NewtoBank from "./pages/customers/newToBank";
import BusinessAccounts from "./pages/account/BusinessAccount";
import BusinessView from "./pages/account/viewBusinessAccount";
import Movies from "./pages/Payments/Movies";
import UserSubscription from "./pages/Payments/UserSubscription";
import LoanDetails from "./pages/Loans/LoanDetails.jsx";
import PreOnboarding from "./pages/Preonboarding/Index.jsx";
import Preonboard from "./pages/Preonboarding/Preonboard.js";
import ViewPreonboard from "./pages/Preonboarding/View-Preonboard.js";
import UpgradeAccount from "./pages/account/UpgradeAccount.jsx";
import OnlineAccountOpening from "./pages/account/OnlineAccountOpening";
import ViewOnlineAccount from "./pages/account/ViewOnlineAccount";
import LivenessImages from "./pages/account/LivenessImages";
import QuickOnlineReferralCodes from "./pages/account/quick-online-referral-codes";
import CreateQuickOnlineReferralCode from "./pages/account/quick-online-referral-codes/create";
import EditQuickOnlineReferralCode from "./pages/account/quick-online-referral-codes/edit";
import ViewQuickOnlineReferralCode from "./pages/account/quick-online-referral-codes/view";
import CashbackedLoans from "./pages/Loans/Cashbackloan.jsx";
import Ratings from "./pages/customers/Ratings.jsx";
import Index from "./pages/compliance/Index.jsx";
import LogPnd from "./pages/compliance/LogPnd.jsx";
import FxTransaction from "./pages/fxTransactions/fxTransaction.js";
import ExchangeRates from "./pages/fxTransactions/fxRate.js";
import TransactionUtilities from "./pages/Transaction_Utilities/index.js";
import FraudulentAccounts from "./pages/Transaction_Utilities/fraudAccount.js";
import { ensureTenantId } from "./utils/tenantHelper.js";
import { enforceSingleTab } from "./utils/sessionGuard.js";
import { listenForForceLogout } from "./utils/tabSync.js";
import Personal from "./pages/Loans/Personal.jsx";
import Payday from "./pages/Loans/Payday.jsx";
import TreasuryListings from "./pages/treasury/listings.jsx";
import CreateEditTreasuryBills from "./pages/treasury/create-edit-t-bills.jsx";
import TreasuryBookings from "./pages/treasury/bookings.jsx";
import ViewTreasuryBookings from "./pages/treasury/viewBookings.jsx";
import TreasuryLiquidation from "./pages/treasury/liquidation.jsx";
import FGBooking from "./pages/fgBonds/bookings.jsx";
import FGListings from "./pages/fgBonds/listings.jsx";
import CreateEditTFGBonds from "./pages/fgBonds/create-view-edit-fgbonds.jsx";
import BondLiquidationList from "./pages/fgBonds/liquidation.jsx";
import FGBookingsView from "./pages/fgBonds/view_booking.jsx";
import ApprovalsList from "./pages/customers/ApprovalsList.js";
import AccountApprovalsList from "./pages/customers/AccountApprovalsList.js";
import AccountOpeningApprovalsList from "./pages/customers/AccountOpeningApprovalsList.js";
import OnboardingStatusHistory from "./pages/customers/OnboardingStatusHistory.js";
import ViewOnboardingStatusHistory from "./pages/customers/ViewOnboardingStatusHistory.js";
import VerificationEmails from "./pages/customers/VerificationEmails.js";
import ViewVerificationEmail from "./pages/customers/ViewVerificationEmail.js";
import ThirdPartyDashboard from "./pages/thirdParty/thirdPartyDashboard.js";
import ThirdPartyEmployees from "./pages/thirdParty/thirdPartyEmployees.js";
import ThirdPartyApplications from "./pages/thirdParty/ThirdPartyApp.js";
import EmployeeDetails from "./pages/thirdParty/employeeDetails.js";
import ThirdPartyOrganizations from "./pages/thirdParty/index.js";
import CreateOrganization from "./pages/thirdParty/ThirdParty.js";
import EditOrganization from "./pages/thirdParty/EditOrganization.js";
import ThirdPartyPayrollOfficer from "./pages/thirdParty/PayrollOfficer.js";
import PayrollOfficerDetails from "./pages/thirdParty/PayrollOfficerDetails.js";
import PreOnboardedPayrollOfficers from "./pages/thirdParty/PreOnboardedPayrollOfficers.js";
import PayrollTransactions from "./pages/thirdParty/PayrollTransactions.js";
import ViewPayrollTransaction from "./pages/thirdParty/ViewPayrollTransaction.js";
import Sidebar from "./components/Layout/Sidebar";
import VirtualCards from "./pages/Cards/VirtualCards";
import ProtectedRoute from "./components/ProtectedRoute";
import HolidayPackages from "./pages/wakanow/holidayPackages";
import CreateHolidayPackage from "./pages/wakanow/createHolidayPackage";
import HolidayPackageRequests from "./pages/wakanow/holidayPackageRequests";
import ViewHolidayPackageRequest from "./pages/wakanow/viewHolidayPackageRequest";
import FlightBookings from "./pages/wakanow/flightBookings";
import ViewFlightBooking from "./pages/wakanow/viewFlightBooking";
import HotelBookings from "./pages/wakanow/hotelBookings";
import ViewHotelBooking from "./pages/wakanow/viewHotelBooking";
// Discount Hub
import DiscountHub from "./pages/discount-hub";
import ReferralCodes from "./pages/discount-hub/referral-codes";
import CreateReferralCode from "./pages/discount-hub/referral-codes/create";
import EditReferralCode from "./pages/discount-hub/referral-codes/edit";
import StaffReferralCodes from "./pages/discount-hub/staff-referral-codes";
import CreateStaffReferralCode from "./pages/discount-hub/staff-referral-codes/create";
import EditStaffReferralCode from "./pages/discount-hub/staff-referral-codes/edit";

function App() {

  const [isActive, setIsActive] = useState(true);
  const [isLogout, setLogout] = useState(false);
  const [tabGuardOk, setTabGuardOk] = useState(false);

  // Ensure tenantId is available when app loads
  useEffect(() => {
    const initializeSession = async () => {
      const token = sessionStorage.getItem("token");
      if (token) {
        await ensureTenantId();
        const allowed = await enforceSingleTab();
        if (!allowed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        setTabGuardOk(true);
      }
    };
    initializeSession();
  }, []);

  useEffect(() => {
    const unsub = listenForForceLogout(() => {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    });
    return unsub;
  }, []);

  const tenant = sessionStorage.getItem("tenantId");
  const isAuthed = !!sessionStorage.getItem("user");

  return (
    <div className="App">
      <IdleTimeOutHandler
        onActive={() => {
          setIsActive(true);
        }}
        onLogout={() => {
          setLogout(true);
        }}
        onIdle={() => {
          setIsActive(false);
        }}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="flex overflow-x-hidden">
        {isAuthed && tabGuardOk && (
        <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
          <Sidebar />
        </div>
        )}
        <div className={`${isAuthed && tabGuardOk ? 'md:pl-64' : ''} flex flex-col flex-1 min-w-0`}>
      {isAuthed && !tabGuardOk ? (
        <div className="flex justify-center items-center min-h-screen">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-500"></div>
        </div>
      ) : (
      <Routes>
        <Route path="/" element={<SignIn />} exact={true} />

        <Route path="/token" element={<Token />} exact={true} />

        <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} exact={true} />
        {/* Application Modules */}
        <Route path="/modules" element={<ApplicationModule />} exact={true} />

        {/* Application settings */}
        <Route
          path="/application/settings"
          element={<ApplicationSettings />}
          exact={true}
        />
        {/* Admin */}

        <Route path="/create/user" element={<CreateUser />} exact={true} />
        <Route path="/update/user" element={<UserUpdate />} exact={true} />
        <Route path="/users" element={<UserManagement />} exact={true} />
        <Route path="/user/view" element={<ViewUser />} exact={true} />
        <Route path="/roles" element={<Roles />} exact={true} />
        <Route path="/notifications" element={<Notifications />} exact={true} />
        <Route path="/create/role" element={<CreaateRole />} exact={true} />
        <Route path="/update/role" element={<UpdateRole />} exact={true} />

        {/* chat */}
        <Route path="/complaints" element={<Complaint />} exact={true} />
        {/* News */}

        <Route path="/posts" element={<AllPosts />} exact={true} />
        <Route path="/create/post" element={<CreatePost />} exact={true} />
        <Route path="/promotion" element={<PushNotification />} exact={true} />
        <Route
          path="/promotion/:id"
          element={<PushNotification />}
          exact={true}
        />
        <Route path="/atm/location" element={<ATMLocation />} exact={true} />
        <Route path="/push/notification" element={<Promotion />} exact={true} />

        {/* AccountOPening */}

        <Route path="/accounts" element={<AccountOpening />} exact={true} />
        <Route path="/online/accounts" element={<OnlineAccountOpening />} exact={true} />
        <Route path="/online/accounts/liveness-images" element={<LivenessImages />} exact={true} />
        <Route path="/online/accounts/referral-codes" element={<QuickOnlineReferralCodes />} exact={true} />
        <Route path="/online/accounts/referral-codes/create" element={<CreateQuickOnlineReferralCode />} exact={true} />
        <Route path="/online/accounts/referral-codes/edit" element={<EditQuickOnlineReferralCode />} exact={true} />
        <Route path="/online/accounts/referral-codes/view" element={<ViewQuickOnlineReferralCode />} exact={true} />
        <Route path="/view/online-account" element={<ViewOnlineAccount />} exact={true} />
        <Route path="/view/account" element={<ViewAccount />} exact={true} />
        <Route
          path="/review/document"
          element={<DocumentReview />}
          exact={true}
        />
        <Route path="/account/comments" element={<AddComment />} exact={true} />
        <Route
          path="/view/sole"
          element={<ViewAccountSoleProprioetorship />}
          exact={true}
        />
        <Route
          path="/view/incorporate"
          element={<ViewAccountIncorporated />}
          exact={true}
        />
        <Route
          path="/minor/accounts"
          element={<MinorAccounts />}
          exact={true}
        />
        <Route path="/view/minor" element={<MinorView />} exact={true} />
        <Route
          path="/salary/accounts"
          element={<SalaryAccounts />}
          exact={true}
        />
        <Route path="/view/salary" element={<SalaryView />} exact={true} />
        <Route path="/officers" element={<AccountOfficer />} exact={true} />
        <Route path="/user/accounts" element={<UserAccounts />} exact={true} />
        <Route
          path="/view/user-account"
          element={<ViewUserAccount />}
          exact={true}
        />
        <Route
          path="/business/accounts"
          element={<BusinessAccounts />}
          exact={true}
        />
        <Route path="/view/business" element={<BusinessView />} exact={true} />
        <Route path="/user/upgrade" element={<UpgradeAccount />} exact={true} />

        {/* Organization */}
        <Route path="/organisation" element={<Tenant />} exact={true} />
        {/* Customer */}
        <Route path="/customers" element={<CustomerList />} exact={true} />
        <Route path="/customer/view" element={<ViewCustomer />} exact={true} />
        <Route
          path="/customer/settings"
          element={<CustomerSettngs />}
          exact={true}
        />
        <Route
          path="/customer/document"
          element={<CustomerDocument />}
          exact={true}
        />
        <Route path="/customer/bvn" element={<BVNDetails />} exact={true} />
        <Route path="/new-to-bank" element={<NewtoBank />} exact={true} />
        <Route path="/customer/reviews" element={<Ratings />} exact={true} />
        <Route path="/approvals" element={<ApprovalsList />} />
        <Route path="/approvals/account-approvals" element={<AccountApprovalsList />} />
        <Route path="/approvals/account-opening-approvals" element={<AccountOpeningApprovalsList />} />
        <Route path="/onboarding-status-history" element={<OnboardingStatusHistory />} exact={true} />
        <Route path="/onboarding-status-history/view" element={<ViewOnboardingStatusHistory />} exact={true} />
        <Route path="/verification-emails" element={<VerificationEmails />} exact={true} />
        <Route path="/verification-emails/view" element={<ViewVerificationEmail />} exact={true} />
        {/* Transfers */}
        <Route path="/transfers" element={<Transfers />} exact={true} />
        <Route
          path="/scheduled/transfers"
          element={<ScheduledTransfers />}
          exact={true}
        />
        <Route
          path="/general/transfers"
          element={<GeneralTransfers />}
          exact={true}
        />
        <Route path="/payrolls" element={<PayRoll />} exact={true} />
        <Route path="/beneficiaries" element={<Beneficiaries />} exact={true} />
        <Route
          path="/beneficiary/view"
          element={<ViewBeneficiary />}
          exact={true}
        />

        {/* Transaction Utilities */}
        <Route path="/utilities" element={<TransactionUtilities />} />
        <Route path="/fraud" element={<FraudulentAccounts />} />

        {/* Investments */}
        <Route path="/investments" element={<Investments />} exact={true} />
        <Route path="/investments/rate" element={<Rates />} exact={true} />

        {/* Foreign exchange */}
        <Route path="/transactions" element={<FxTransaction />} exact={true} />
        <Route path="/rates" element={<ExchangeRates />} exact={true} />

        {/* Rewards */}
        <Route path="/rewards" element={<Rewards />} exact={true} />

        {/* Cheques */}
        <Route
          path="/confirm/cheque"
          element={<ConfirmedCheque />}
          exact={true}
        />
        <Route path="/request/cheque" element={<ChequeBook />} exact={true} />
        <Route path="/draft" element={<DraftRequests />} exact={true} />
        <Route path="/stop/cheque" element={<StopCheque />} exact={true} />

        {/* Debit cards */}
        <Route path="/active/card" element={<ActiveCards />} exact={true} />
        <Route path="/request/card" element={<CardRequest />} exact={true} />
        <Route path="/block/card" element={<BlockCards />} exact={true} />
        <Route path="/virtual/cards" element={<VirtualCards />} exact={true} />

        {/* payment */}
        <Route path="/payment/bill" element={<BillPayment />} exact={true} />
        <Route path="/payment/recharge" element={<Recharge />} exact={true} />
        <Route path="/payment/movies" element={<Movies />} exact={true} />
        <Route
          path="/payment/view-movie"
          element={<UserSubscription />}
          exact={true}
        />

        {/* Pos Request */}
        <Route path="/pos" element={<POSRequest />} exact={true} />

        {/* Loans */}
        <Route path="/loan/payday" element={<Payday />} exact={true} />
        <Route path="/loan/personal" element={<Personal />} exact={true} />
        <Route
          path="/loan/cashback"
          element={<CashbackedLoans />}
          exact={true}
        />
        <Route path="/loan/view" element={<LoanDetails />} exact={true} />
        <Route
          path="/payday/settings"
          element={<PaydaySettings />}
          exact={true}
        />
        <Route
          path="/cashback/settings"
          element={<CashbasedSettings />}
          exact={true}
        />

        {/* deposit */}
        <Route path="/deposits" element={<Deposits />} exact={true} />

        {/* withdrawals */}
        <Route path="/withdrawals" element={<Withdrawals />} exact={true} />
        <Route
          path="/withdrawal/pickup"
          element={<CashPickUp />}
          exact={true}
        />
        <Route path="/pickup/view" element={<ViewPickUp />} exact={true} />

        <Route path="/budgets" element={<Budget />} exact={true} />
        {/* Auditlogs */}
        <Route path="/admin/audit" element={<AdminAudit />} exact={true} />
        <Route
          path="/customer/audit"
          element={<CustomerAudit />}
          exact={true}
        />

        {/* Preonboarding*/}
        <Route path="/preonboard" element={<PreOnboarding />} exact={true} />
        <Route
          path="/create/preonboard"
          element={<Preonboard />}
          exact={true}
        />
        <Route
          path="/preonboard/view/"
          element={<ViewPreonboard />}
          exact={true}
        />

        {/* Third Party */}
        <Route
          path="/thirdparty"
          element={<ThirdPartyDashboard />}
          exact={true}
        />
        <Route
          path="/thirdparty/organizations"
          element={<ThirdPartyOrganizations />}
          exact={true}
        />
        <Route
          path="/thirdparty/organizations/create"
          element={<CreateOrganization />}
          exact={true}
        />
        <Route
          path="/thirdparty/applications"
          element={<ThirdPartyApplications />}
          exact={true}
        />
        <Route
          path="/thirdparty/employees"
          element={<ThirdPartyEmployees />}
          exact={true}
        />
        <Route
          path="/thirdparty/employees/:organizationId/:customerId"
          element={<EmployeeDetails />}
          exact={true}
        />
        <Route
          path="/thirdparty/organizations/edit/:organizationId"
          element={<EditOrganization />}
          exact={true}
        />
        <Route path="/thirdparty/payroll-officers" element={<ThirdPartyPayrollOfficer />} exact={true} />
        <Route path="/thirdparty/payroll-officers/:organizationId/:payrollOfficerId/view" element={<PayrollOfficerDetails />} exact={true} />
        <Route path="/thirdparty/pre-onboarded-payroll-officers" element={<PreOnboardedPayrollOfficers />} exact={true} />
        <Route path="/thirdparty/payroll-transactions" element={<PayrollTransactions />} exact={true} />
        <Route path="/thirdparty/payroll-transactions/:tenantId/:userId/:payrollTransactionId/view" element={<ViewPayrollTransaction />} exact={true} />

        {/*Compliance sheet*/}
        <Route path="/compliance/sheets" element={<Index />} exact={true} />
        <Route path="/compliance/log" element={<LogPnd />} exact={true} />

        {/*Treasury Bill*/}
        <Route path="/treasury" element={<TreasuryListings />} exact={true} />
        <Route path="/treasury/:slug" element={<CreateEditTreasuryBills />} />
        <Route path="/bookings" element={<TreasuryBookings />} exact={true} />
        <Route
          path="/bookings/:bookingId"
          element={<ViewTreasuryBookings />}
          exact={true}
        />
        <Route
          path="/liquidation"
          element={<TreasuryLiquidation />}
          exact={true}
        />

        {/*FGBonds */}
        <Route path="/fgn-bonds" element={<FGListings />} exact={true} />
        <Route path="/fgn_bonds/:slug" element={<CreateEditTFGBonds />} />
        <Route
          path="/fgn-bonds/bookings"
          element={<FGBooking />}
          exact={true}
        />
        <Route
          path="/fgn_bookings/:bookingId"
          element={<FGBookingsView />}
          exact={true}
        />
        <Route
          path="/fgn-bonds/liquidation"
          element={<BondLiquidationList />}
          exact={true}
        />
        </Route>

        {/* Wakanow */}
        <Route path="/wakanow/holiday-packages" element={<HolidayPackages />} exact={true} />
        <Route path="/wakanow/holiday-packages/:slug" element={<CreateHolidayPackage />} />
        <Route path="/wakanow/holiday-package-requests" element={<HolidayPackageRequests />} exact={true} />
        <Route path="/wakanow/holiday-package-requests/:id" element={<ViewHolidayPackageRequest />} exact={true} />
        <Route path="/wakanow/flight-bookings" element={<FlightBookings />} exact={true} />
        <Route path="/wakanow/flight-bookings/:id" element={<ViewFlightBooking />} exact={true} />
        <Route path="/wakanow/hotel-bookings" element={<HotelBookings />} exact={true} />
        <Route path="/wakanow/hotel-bookings/:id" element={<ViewHotelBooking />} exact={true} />

        {/* Discount hub */}
      <Route path="/discount-hub" element={<DiscountHub />} />
      <Route path="/discount-hub/referral-codes" element={<ReferralCodes />} />
      <Route path="/discount-hub/referral-codes/create" element={<CreateReferralCode />} />
      <Route path="/discount-hub/referral-codes/edit" element={<EditReferralCode />} />
      <Route path="/discount-hub/staff-referral-codes" element={<StaffReferralCodes />} />
      <Route path="/discount-hub/staff-referral-codes/create" element={<CreateStaffReferralCode />} />
      <Route path="/discount-hub/staff-referral-codes/edit" element={<EditStaffReferralCode />} />
      </Routes>
      )}
        </div>
      </div>
    </div>
  );
}

export default App;
